import type { ApiClient } from './runtime/apiRuntime';
import { apiMutationOptions, BaseApiMutationOptions } from './apiMutationOptions';
import { apiQueryOptions, BaseApiQueryOptions } from './apiQueryOptions';

export const AccountInviteApi = {
    get: (accountInviteId: string, options?: BaseApiQueryOptions) =>
        apiQueryOptions(['accountInvite', 'get', accountInviteId], (api) => api.accountInvite.get(accountInviteId), options),
    accept: (options?: BaseApiMutationOptions<ApiClient['accountInvite']['accept']>) => apiMutationOptions((api) => api.accountInvite.accept, options),
    reject: (options?: BaseApiMutationOptions<ApiClient['accountInvite']['reject']>) => apiMutationOptions((api) => api.accountInvite.reject, options)
};
